import { render, staticRenderFns } from "./OrganizationBranchDailyWork.vue?vue&type=template&id=24128c63&scoped=true"
import script from "./OrganizationBranchDailyWork.vue?vue&type=script&lang=js"
export * from "./OrganizationBranchDailyWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24128c63",
  null
  
)

export default component.exports